import React from 'react'
import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/table';
import axios from "axios";
import base_url from '../../utils/getlink';
import { useEffect } from 'react';
import { useState } from 'react';
const UsersShow = () => {
  const [userData,setUserData]=useState([]);
  useEffect(()=>{
    axios({
      method:'get',
      url:`${base_url}/users/getuser?role=user`
    }).then((res)=>{
      setUserData(res.data);
    }).catch((err)=>{
      console.log(err);
      console.log("something went wrong.");
    });
    
  },[setUserData])
  
  return (
    <div style={{
      overflowY:"scroll",
      maxHeight:"80vh"
    }}>
      <Table>
        <Thead>
          <Tr>
          <Th>Name</Th><Th>email</Th><Th>orders</Th>
          </Tr>
        </Thead>
        <Tbody>
          {userData.length>0&&userData.map((user)=>{
            return (<Tr key={user._id}>
              <Td>{user.name}</Td>
              <Td>{user.email}</Td>
              <Td>0</Td>
            </Tr>)
          })}
        </Tbody>
      </Table>
    </div>
  )
}

export default UsersShow